(() => {
  const SELECTOR = ".js-inview-anim";

  const markAllInViewFallback = () => {
    document.querySelectorAll(SELECTOR).forEach((el) => el.classList.add("is-inview"));
  };

  const observeInView = () => {
    const els = Array.from(document.querySelectorAll(SELECTOR));
    if (!els.length) return;

    if (!("IntersectionObserver" in window)) {
      markAllInViewFallback();
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle("is-inview", entry.isIntersecting);
        });
      },
      { threshold: 0.35 }
    );

    els.forEach((el) => io.observe(el));
  };

  const init = () => observeInView();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:reorder", init);
  document.addEventListener("variant:change", init);

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(SELECTOR) || node.querySelector?.(SELECTOR)) {
          init();
          return;
        }
      }
    }
  });

  const startMO = () => {
    if (!document.body) return;
    mo.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startMO);
  } else {
    startMO();
  }
})();